// Carousel actions
document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".carousel");
  const arrowBtns = document.querySelectorAll(".wrapper i");
  const wrapper = document.querySelector(".wrapper");
  const tabLinks = document.querySelectorAll(".tablinks");

  const firstCard = carousel.querySelector(".card");
  const firstCardWidth = firstCard.offsetWidth;

  let timeoutId;
  const delay = 3000;

  const autoPlay = () => {
    // Return if window is smaller than 800
    if (window.innerWidth < 800) return;

    // Calculate the total width of all cards
    const totalCardWidth = carousel.scrollWidth;

    // Calculate the maximum scroll position
    const maxScrollLeft = totalCardWidth - carousel.offsetWidth;

    // If the carousel is at the end, stop autoplay
    if (carousel.scrollLeft >= maxScrollLeft) {
      timeoutId = setTimeout(() => (carousel.scrollLeft = 0), delay);
    } else {
      // Autoplay the carousel after every 2500ms
      timeoutId = setTimeout(
        () => (carousel.scrollLeft += firstCardWidth),
        delay
      );
    }
  };

  // Pause autoplay when the mouse enters the wrapper
  wrapper.addEventListener("mouseenter", () => clearTimeout(timeoutId));
  // Resume autoplay when the mouse leaves the wrapper
  // wrapper.addEventListener("mouseleave", autoPlay);

  // Add event listeners for the arrow buttons to scroll the carousel left and right
  arrowBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      carousel.scrollLeft +=
        btn.id === "left" ? -firstCardWidth : firstCardWidth;
    });
  });

  // Reset carousel position when tab links are clicked
  tabLinks.forEach((link) => {
    link.addEventListener("click", () => {
      carousel.scrollLeft = 0; // Scroll back to the first card
    });
  });
});
